"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useListSavedPaymentMethods = void 0;
const tslib_1 = require("tslib");
/*
Copyright (C) 2009 - 2021 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
const react_1 = require("react");
const axios_1 = (0, tslib_1.__importDefault)(require("axios"));
const internal_1 = require("../internal");
/**
 * Allows retrieving a list of active saved payment methods for the given owner.
 */
const useListSavedPaymentMethods = (props) => {
    const { authState, savedPaymentMethodClient, previewOptions, owningUserType, owningUserId } = props;
    const getCustomerToken = (0, internal_1.useGetCustomerAccessToken)({ authState });
    const [isFetching, setIsFetching] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)();
    const [savedPaymentMethods, setSavedPaymentMethods] = (0, react_1.useState)([]);
    const { isAuthenticated } = authState;
    const loadSavedPaymentMethods = (0, react_1.useCallback)(() => (0, tslib_1.__awaiter)(void 0, void 0, void 0, function* () {
        var _a;
        if (!isAuthenticated) {
            return [];
        }
        try {
            setIsFetching(true);
            const accessToken = yield getCustomerToken();
            const { content } = yield savedPaymentMethodClient.listSavedPaymentMethods(owningUserType, owningUserId, {
                accessToken,
                preview: previewOptions
            });
            setError(undefined);
            setSavedPaymentMethods(content);
            return content;
        }
        catch (error) {
            if (axios_1.default.isCancel(error)) {
                // do nothing if cancelled
                return [];
            }
            if (axios_1.default.isAxiosError(error)) {
                setError((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
                return [];
            }
            setError(error);
            return [];
        }
        finally {
            setIsFetching(false);
        }
    }), [
        savedPaymentMethodClient,
        owningUserType,
        owningUserId,
        getCustomerToken,
        isAuthenticated,
        previewOptions
    ]);
    (0, react_1.useEffect)(() => {
        loadSavedPaymentMethods();
    }, [loadSavedPaymentMethods]);
    return {
        isFetching,
        error,
        savedPaymentMethods,
        refetch: loadSavedPaymentMethods
    };
};
exports.useListSavedPaymentMethods = useListSavedPaymentMethods;
//# sourceMappingURL=use-list-saved-payment-methods.js.map